/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SignalGeneratorChannelFragment = {
	id: string;
	description: {
		group: Types.AudioChannelGroup;
		constraints: {
			signalGenerator: {
				signalTypes: Array<{
					signalType: Types.SignalType;
					powerSources: Array<{
						powerSourceType: Types.SignalGeneratorPowerSourceType;
						gainRanges: Array<{
							frequencyRange: { range: { max: number; min: number; step: number } };
							gainRange: { range: { max: number; min: number; step: number } };
						}>;
					}>;
				}>;
			} | null;
		};
		features: { signalGenerator: { supported: boolean }; channelConfiguration: { supported: boolean } };
	};
	features: {
		signalGenerator: { enabled: boolean; frequency: number; gain: number; signalType: Types.SignalType } | null;
		name: { name: string } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type SignalGeneratorSignalTargetChannelFragment = {
	id: string;
	description: { group: Types.AudioChannelGroup; features: { matrixMixerOutput: { supported: boolean } } };
	features: {
		matrixMixerOutput: { crossPoints: Array<SignalGeneratorCrossPointFragment> } | null;
		name: { name: string } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type SignalGeneratorCrossPointFragment = {
	id: string;
	features: { configuration: { enabled: boolean | null } | null };
	inputChannel: { id: string; description: { group: Types.AudioChannelGroup } } | {};
};

export type SignalGeneratorCrossPointChangeFragment = {
	id: string;
	features: { configuration: { enabled: boolean | null } | null } | {};
};

export type SignalGeneratorChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { name: { name: string } | null }
		| {
				signalGenerator: {
					enabled: boolean;
					frequency: number;
					gain: number;
					signalType: Types.SignalType;
				} | null;
		  }
		| {};
};

export type SignalGeneratorChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type SignalGeneratorChannelQueryOpResult = { node: SignalGeneratorChannelFragment | {} };

export type SignalGeneratorSignalTargetQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type SignalGeneratorSignalTargetQueryOpResult = { node: SignalGeneratorSignalTargetChannelFragment | {} };

export type SignalGeneratorChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type SignalGeneratorChannelSubscriptionOpResult = {
	nodeChanges: SignalGeneratorChannelFragment | SignalGeneratorChannelUpdateFragment | {};
};

export type SignalGeneratorCrossPointSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type SignalGeneratorCrossPointSubscriptionOpResult = {
	nodeChanges: SignalGeneratorChannelUpdateFragment | SignalGeneratorCrossPointChangeFragment | {};
};

export type SignalGeneratorSignalTargetSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type SignalGeneratorSignalTargetSubscriptionOpResult = {
	nodeChanges: SignalGeneratorSignalTargetChannelFragment | SignalGeneratorChannelUpdateFragment | {};
};

export type SignalGeneratorChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type SignalGeneratorChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export type SignalGeneratorSignalTargetMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type SignalGeneratorSignalTargetMutationOpResult = {
	updateNodes: Array<
		| {
				crossPoint: { id: string; features: { configuration: { enabled: boolean | null } | null } } | null;
				error: { code: Types.ErrorCode; message: string } | null;
		  }
		| {}
	>;
};

export const SignalGeneratorChannelFragment = gql`
	fragment SignalGeneratorChannelFragment on AudioChannel {
		id
		description {
			group
			constraints {
				signalGenerator {
					signalTypes {
						powerSources {
							gainRanges {
								frequencyRange {
									range {
										max
										min
										step
									}
								}
								gainRange {
									range {
										max
										min
										step
									}
								}
							}
							powerSourceType
						}
						signalType
					}
				}
			}
			features {
				signalGenerator {
					supported
				}
				channelConfiguration {
					supported
				}
			}
		}
		features {
			signalGenerator {
				enabled
				frequency
				gain
				signalType
			}
			name {
				name
			}
			channelConfiguration {
				enabled
			}
		}
	}
`;
export const SignalGeneratorCrossPointFragment = gql`
	fragment SignalGeneratorCrossPointFragment on CrossPoint {
		id
		features {
			configuration {
				enabled
			}
		}
		inputChannel {
			... on AudioChannel {
				id
				description {
					group
				}
			}
		}
	}
`;
export const SignalGeneratorSignalTargetChannelFragment = gql`
	fragment SignalGeneratorSignalTargetChannelFragment on AudioChannel {
		id
		description {
			group
			features {
				matrixMixerOutput {
					supported
				}
			}
		}
		features {
			matrixMixerOutput {
				crossPoints {
					...SignalGeneratorCrossPointFragment
				}
			}
			name {
				name
			}
			channelConfiguration {
				enabled
			}
		}
	}
	${SignalGeneratorCrossPointFragment}
`;
export const SignalGeneratorCrossPointChangeFragment = gql`
	fragment SignalGeneratorCrossPointChangeFragment on CrossPointChange {
		id
		features {
			... on CrossPointConfigurationChange {
				configuration {
					enabled
				}
			}
		}
	}
`;
export const SignalGeneratorChannelUpdateFragment = gql`
	fragment SignalGeneratorChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelSignalGeneratorChange {
				signalGenerator {
					enabled
					frequency
					gain
					signalType
				}
			}
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const SignalGeneratorChannelQueryDocument = gql`
	query SignalGeneratorChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...SignalGeneratorChannelFragment
		}
	}
	${SignalGeneratorChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorChannelQueryGQL extends Apollo.Query<
	SignalGeneratorChannelQueryOpResult,
	SignalGeneratorChannelQueryVariables
> {
	override document = SignalGeneratorChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const SignalGeneratorSignalTargetQueryDocument = gql`
	query SignalGeneratorSignalTargetQuery($channelId: ID!) {
		node(id: $channelId) {
			...SignalGeneratorSignalTargetChannelFragment
		}
	}
	${SignalGeneratorSignalTargetChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorSignalTargetQueryGQL extends Apollo.Query<
	SignalGeneratorSignalTargetQueryOpResult,
	SignalGeneratorSignalTargetQueryVariables
> {
	override document = SignalGeneratorSignalTargetQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const SignalGeneratorChannelSubscriptionDocument = gql`
	subscription SignalGeneratorChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...SignalGeneratorChannelFragment
			}
			... on AudioChannelChange {
				...SignalGeneratorChannelUpdateFragment
			}
		}
	}
	${SignalGeneratorChannelFragment}
	${SignalGeneratorChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorChannelSubscriptionGQL extends Apollo.Subscription<
	SignalGeneratorChannelSubscriptionOpResult,
	SignalGeneratorChannelSubscriptionVariables
> {
	override document = SignalGeneratorChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const SignalGeneratorCrossPointSubscriptionDocument = gql`
	subscription SignalGeneratorCrossPointSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...SignalGeneratorCrossPointChangeFragment
			...SignalGeneratorChannelUpdateFragment
		}
	}
	${SignalGeneratorCrossPointChangeFragment}
	${SignalGeneratorChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorCrossPointSubscriptionGQL extends Apollo.Subscription<
	SignalGeneratorCrossPointSubscriptionOpResult,
	SignalGeneratorCrossPointSubscriptionVariables
> {
	override document = SignalGeneratorCrossPointSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const SignalGeneratorSignalTargetSubscriptionDocument = gql`
	subscription SignalGeneratorSignalTargetSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			...SignalGeneratorSignalTargetChannelFragment
			...SignalGeneratorChannelUpdateFragment
		}
	}
	${SignalGeneratorSignalTargetChannelFragment}
	${SignalGeneratorChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorSignalTargetSubscriptionGQL extends Apollo.Subscription<
	SignalGeneratorSignalTargetSubscriptionOpResult,
	SignalGeneratorSignalTargetSubscriptionVariables
> {
	override document = SignalGeneratorSignalTargetSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const SignalGeneratorChannelMutationDocument = gql`
	mutation SignalGeneratorChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorChannelMutationGQL extends Apollo.Mutation<
	SignalGeneratorChannelMutationOpResult,
	SignalGeneratorChannelMutationVariables
> {
	override document = SignalGeneratorChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const SignalGeneratorSignalTargetMutationDocument = gql`
	mutation SignalGeneratorSignalTargetMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on CrossPointOperationResult {
				crossPoint {
					id
					features {
						configuration {
							enabled
						}
					}
				}
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class SignalGeneratorSignalTargetMutationGQL extends Apollo.Mutation<
	SignalGeneratorSignalTargetMutationOpResult,
	SignalGeneratorSignalTargetMutationVariables
> {
	override document = SignalGeneratorSignalTargetMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
